import { render, staticRenderFns } from "./FileReview.vue?vue&type=template&id=116d4d4e&scoped=true&"
import script from "./FileReview.vue?vue&type=script&lang=js&"
export * from "./FileReview.vue?vue&type=script&lang=js&"
import style0 from "./FileReview.vue?vue&type=style&index=0&id=116d4d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d4d4e",
  null
  
)

export default component.exports